import { createIcon } from '@chakra-ui/react';

export const SubscriptionWarningIcon = createIcon({
  displayName: 'SubscriptionWarningIcon',
  viewBox: '0 0 16 16',
  defaultProps: {
    fill: 'none',
    height: '4',
    width: '4',
  },
  path: (
    <>
      <path
        d="M7.40527 1.54297C7.68929 1.25895 8.15055 1.25895 8.43457 1.54297L14.377 7.48535C14.661 7.76937 14.661 8.23063 14.377 8.51465L8.43457 14.457C8.15055 14.741 7.68929 14.741 7.40527 14.457L1.46289 8.51465C1.17887 8.23063 1.17887 7.76937 1.46289 7.48535L7.40527 1.54297Z"
        fill="#E67635"
        stroke="#E67635"
        strokeWidth={1.45455}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.91992 4.6665V8.33317"
        stroke="white"
        strokeWidth={1.33333}
        strokeLinecap="round"
      />
      <circle
        cx={7.92008}
        cy={10.6667}
        r={0.333333}
        fill="#E67635"
        stroke="white"
        strokeWidth={0.666667}
      />
    </>
  ),
});
